"use client";

// Die 5-Balken-Ladeanimation, die LoadingScreen und SplashScreen beide zeichnen.
// `keyframeName` bleibt ein Parameter statt eines festen globalen Namens, damit
// zwei gleichzeitig gemountete Instanzen (z.B. Splash ueber Loading) sich nicht
// denselben CSS-`@keyframes`-Block teilen muessen.
interface BarSpinnerProps {
  keyframeName: string;
  /** Zusaetzliche Styles fuer den Balken-Container (z.B. Splash-Fade-Transition). */
  containerStyle?: React.CSSProperties;
}

const BAR_DELAYS = ["-0.6s", "-0.48s", "-0.36s", "-0.24s", "-0.12s"];

export function barSpinnerKeyframes(keyframeName: string): string {
  return `
    @keyframes ${keyframeName} {
      0%, 100% {
        opacity: 0.3;
        transform: translateZ(0) skewX(-20deg) scale3d(1.2, 1.45, 1);
      }
      42% {
        opacity: 0;
        transform: translateZ(0) skewX(-20deg) scale3d(1.2, 1.45, 1);
      }
      50% {
        opacity: 1;
        transform: translateZ(0) skewX(-20deg) scale3d(1, 1, 1);
      }
    }
  `;
}

export function BarSpinner({ keyframeName, containerStyle }: BarSpinnerProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "8px 16px",
        contain: "layout paint",
        isolation: "isolate",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        ...containerStyle,
      }}
    >
      {BAR_DELAYS.map((delay, i) => (
        <div
          key={i}
          style={{
            position: "relative",
            width: 9,
            height: 26,
            borderRadius: 3,
            backgroundColor: "currentColor",
            transform: "translateZ(0) skewX(-20deg)",
            transformOrigin: "center",
            animation: `${keyframeName} 1.2s ease-in-out infinite`,
            animationDelay: delay,
            willChange: "transform, opacity",
          }}
        />
      ))}
    </div>
  );
}
